import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur söker jag tillstånd för uteservering?";
const SHORT_ANSWER = "Du anger uteserveringen på ritningen i din ansökan om serveringstillstånd, och söker separat markupplåtelse hos kommunens trafik- eller parkförvaltning om marken ägs av kommunen.";

export const Route = createFileRoute("/fraga/hur-soker-jag-uteservering")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur söker jag tillstånd för uteservering" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Två parallella prövningar: kommunens tillståndsenhet bedömer alkoholservering, gata/park bedömer markanvändning. Räkna med 4–8 veckor extra om uteservering tillkommer sent. Sommarsäsongen är hård – sök senast i februari–mars."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Serveringstillstånd – steg för steg" }}
      related={[{"to": "/fraga/vad-ar-provsmakningstillstand", "label": "Vad är ett provsmakningstillstånd?"}, {"to": "/fraga/kan-jag-overlata-mitt-tillstand", "label": "Kan jag överlåta mitt serveringstillstånd till en ny ägare?"}, {"to": "/fraga/far-jag-ha-uteservering", "label": "Får jag ha uteservering med serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur söker jag tillstånd för uteservering?" },
      { name: "description", content: "Du anger uteserveringen på ritningen i din ansökan om serveringstillstånd, och söker separat markupplåtelse hos kommunens trafik- eller parkförvaltning om ma…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-soker-jag-uteservering" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-soker-jag-uteservering" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-soker-jag-uteservering",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur söker jag tillstånd för uteservering", url: "https://alkoholprovet.se/fraga/hur-soker-jag-uteservering" },
      ]),
    ],
  }),
});
